import React from "react";
import SVG from "../../svg/Svg";
import "./logo.css";

const HeaderLogo = () => {
  return <div className="header_logo">{SVG["mainLogo"]}</div>;
};

export default HeaderLogo;
